import styled from 'styled-components';

// COLORS
import { WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  border-radius: 20px;
  overflow: hidden;
  background-color: ${WHITE};

  .banner-dynamic {
    &__section-right {
      background-color: ${WHITE};
    }

    &__content-left {
      padding: 24px 48px 24px 60px;
    }

    &__title {
      font-size: 3.2rem;
      line-height: 4.2rem;
      margin-bottom: 12px;
    }

    &__text {
      font-size: 2rem;
      line-height: 2.2rem;
      margin-bottom: 24px;
    }

    &__image {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;

      img {
        max-width: 100%;
      }
    }
  }
  ${breakpoints.down('md')} {
    .banner-dynamic {
      &__title {
        font-size: 2.2rem;
        line-height: 3.2rem;
      }

      &__text {
        font-size: 1.6rem;
        line-height: 2.2rem;
        margin-bottom: 24px;
      }
    }
  }
  ${breakpoints.down('sm')} {
    .banner-dynamic {
      &__title {
        font-size: 2rem;
        line-height: 2.2rem;
        margin-bottom: 12px;
      }

      &__text {
        font-size: 1.3rem;
        line-height: 1.6rem;
        margin-bottom: 24px;
      }
    }
  }

  ${breakpoints.down('xs')} {
    .banner-dynamic {
      &__content-left {
        padding: 15px 30px;
      }

      &__title {
        margin-bottom: 15px;
      }
    }
  }
`;

export default Container;
